<template>
  <div>
    <Edit_employee/>
  </div>
</template>

<script>
import Edit_employee from "@/components/adminArin/admin_overall/Edit_employee";
export default {
  name: "EditEmployee",
  components: {
    Edit_employee
  }
}
</script>

<style scoped>

</style>
